import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {setError, setAddressValues, setChosenSubscription, goToPage, reportDWH} from '../StandAlonePurchaseSaleSlice';
import {ePages, eErrors} from '../Constants';
import Property from '@episerver/spa-core/Components/Property';
import CircleArrowIcon from '../Assets/CircleArrowIcon.svg';
import TvIcon from '../Assets/TvIcon.svg';

const SubscriptionsInfoPage = (props) => {
  useEffect(() => {
    if (props.tvProducts.length === 0 && !props.isLoading) {
      props.reportDWH({
        actionType: 'Entered Not Supported Page',
        statusText: 'Error',
        messageText: 'Equipment Not Supported',
      });
      props.setError({id: eErrors.TV_SERVICE_NOT_FOUND});
    }
    if (props.tvProducts.length === 1) {
      handleTvSubscriptionButtonClick(props.tvProducts[0]);
    }
    if (props.tvProducts.length > 1) {
      props.reportDWH({
        actionType: 'Entered MultiTV Page',
        statusText: 'Ongoing',
        messageText: 'Entered MultiTV Page',
      });
    }
  }, [props.tvProducts, props.isLoading]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.isLoading]);

  function checkForRightEquipmentBeforePurchase(prd) {
    try {
      for (let eqp of prd['equipment']) {
        for (let item of eqp['serialItems']['serialItem']) {
          if (item['sku'].slice(-6) === props.productId) {
            return true;
          }
        }
      }
    } catch (e) {
      console.log(`@@@ checking for the right equipment EXCEPTION => ${e.message}`);
    }
    return false; // user does not have the right equipment for purchasing the product
  }

  function handleTvSubscriptionButtonClick(prd) {
    props.reportDWH({
      actionType: 'ChooseTV Clicked',
      statusText: 'Ongoing',
      messageText: 'ChooseTV Clicked',
      param1: prd.userName,
    });
    if (!prd.hasFinancialIssue) {
      if (props.productId !== '') {
        const isUserHaveTheRightEquipment = checkForRightEquipmentBeforePurchase(prd); // if productId not empty filter customers by productId
        if (isUserHaveTheRightEquipment) {
          props.setChosenSubscription(prd.ban);
          props.reportDWH({
            actionType: 'Entered Choosing Eq Page',
            statusText: 'Ongoing',
            messageText: 'Entered Choosing Eq Page',
          });
          props.goToPage({page: ePages.PRODUCT_PURCHASE_PAGE, percent: '20'});
        } else {
          props.reportDWH({
            actionType: 'Entered Not Supported Page',
            statusText: 'Error',
            messageText: 'Equipment Not Supported',
          });
          props.setError({id: eErrors.REQUIRED_EQUIPMENT_NOT_FOUND});
        }
      } else {
        // no need to filter customers by productId
        props.setChosenSubscription(prd.ban);
        props.goToPage({page: ePages.PRODUCT_PURCHASE_PAGE, percent: '20'});
      }
    } else {
      props.reportDWH({
        actionType: 'Enter Financial Message Page',
        statusText: 'Error',
        messageText: "Can't order financial problem",
        param1: 'DEBT/NO_PAYMENT',
      });
      props.setError({id: eErrors.FINANCIAL_ISSUE});
    }
  }

  return (
    !props.isLoading &&
    props.tvProducts.length > 1 && (
      <div className='subscriptions-info-page'>
        <Property
          className='subscriptions-info-page__title'
          context={props.context}
          iContent={props.iContent}
          field='subscribersPageTitle'
        />
        {props.tvProducts.map((prd, idx) => {
          return (
            <div key={idx} className='subscriptions-info-page__card'>
              <div className='subscriptions-info-page__holder subscriptions-info-page__holder--1'>
                <Image className='subscriptions-info-page__tv-icon' src={TvIcon} alt='tv icon' />
                <span>מנוי {window.Config.brand_Name_HE} TV</span>
              </div>
              <div className='subscriptions-info-page__holder subscriptions-info-page__holder--2'>
                <span>{prd.userName}</span>
                <span>{prd.fullAddress}</span>
              </div>
              <Image className='subscriptions-info-page__btn-icon'
                src={CircleArrowIcon}
                alt='btn'
                onClick={() => handleTvSubscriptionButtonClick(prd)} />
            </div>
          );
        })}
      </div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    productId: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productId?.value ?? '',
    iContent: state.standAlonePurchaseSaleBlock?.epiContent?.iContent,
    tvProducts: state.standAlonePurchaseSaleBlock?.tvProducts,
    isLoading: state.loader?.isLoading,
  };
};

const mapDispatchToProps = {
  setError,
  setAddressValues,
  setChosenSubscription,
  goToPage,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionsInfoPage);
